import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { string } from 'prop-types';
import { useListContext } from './list-context';
import { ItemWrapper } from './list.styles';

const withWrapper = Component => {
  const wrapper = _ref => {
    let {
      as: childType
    } = _ref,
        props = _objectWithoutPropertiesLoose(_ref, ["as"]);

    const {
      type: parentType
    } = useListContext();

    if (['ul', 'ol'].includes(parentType) && childType === 'a') {
      return /*#__PURE__*/React.createElement(ItemWrapper, null, /*#__PURE__*/React.createElement(Component, _extends({
        as: childType
      }, props)));
    }

    return /*#__PURE__*/React.createElement(Component, _extends({
      as: ['ul', 'ol'].includes(parentType) ? 'li' : 'div'
    }, props));
  };

  process.env.NODE_ENV !== "production" ? wrapper.propTypes = {
    as: string
  } : void 0;
  wrapper.defaultProps = {
    as: ''
  };
  return wrapper;
};

export default withWrapper;